import store from '../redux/store';
import {setIsLoggedIn} from '../redux/actions/auth';

// Keep screen state compatible while the integration wire format uses camelCase.
const integrationFields = {
  "pph_company_id": "pphCompanyId",
  "company_id": "companyId",
  "payroll_adjustments": "payrollAdjustments",
  "pay_month": "payMonth",
  "pay_year": "payYear",
  "payroll_period_id": "payrollPeriodId",
  "payroll_frequency_id": "payrollFrequencyId",
  "pay_group_id": "payGroupId",
  "pay_date": "payDate",
  "payroll_periods": "payrollPeriods",
  "payroll_frequencies": "payrollFrequencies",
  "pay_groups": "payGroups",
  "is_deferred_enabled": "isDeferredEnabled",
  "synced_at": "syncedAt"
};
const translateIntegration = (value, names) => {
  if (Array.isArray(value)) return value.map(item => translateIntegration(item, names));
  if (!value || typeof value !== 'object') return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [names[key] || key, translateIntegration(item, names)]));
};
const screenFields = Object.fromEntries(Object.entries(integrationFields).map(([a, b]) => [b, a]));

const request = async (action, options, isNotJSON) => {
    let paramOptions = options ? options : {};
    const isHeadersNull = paramOptions.headers === null ? true : false;

    if (!paramOptions.headers) {
        paramOptions.headers = {};
    }

    let defaultHeaders = {};

    if (isNotJSON !== true && isHeadersNull !== true) {
        defaultHeaders["Accept"] = "application/json";
        defaultHeaders["Content-Type"] = "application/json";
    }

    const { headers, ...others } = paramOptions;

    let opt = {
        headers: {
            ...defaultHeaders,
            ...headers,
        },
        ...others,
    }

    const usesIntegrationContract = /^\/api\/(activity|integration)(\/|\?|$)/.test(action);
    if (usesIntegrationContract && typeof opt.body === 'string') {
      opt.body = JSON.stringify(translateIntegration(JSON.parse(opt.body), integrationFields));
    }
    let response = await fetch(action, opt);
    let responseJSON

    if (isNotJSON !== true) {
        responseJSON = await response.json();
        if (usesIntegrationContract) responseJSON = translateIntegration(responseJSON, screenFields);
    }
    else {
        responseJSON = response;
    }

    if (responseJSON.is_force_signout === true) {
        store.dispatch(setIsLoggedIn(false));
        window.location.href="/signin";
    }
    else {
        return responseJSON;
    }
}

export {
    request,
}
